<template>
	<div ref="container" :style="setStyle"></div>
</template>

<script>
export default {
	name: 'ShadowDOMContainer',
	props: {
		/** 需要渲染到Shadow DOM中的内容 */
		content: {
			type: String,
			default: '',
			required: false,
		},
		/** 应用于容器元素的样式 */
		setStyle: {
			type: Object,
			default: () => ({}),
			required: false,
		},
		/** Shadow DOM的模式，可选值为'open'或'closed' */
		shadowMode: {
			type: String,
			default: 'open',
			validator: value => ['open', 'closed'].includes(value),
		},
	},
	data() {
		return {
			// 存储Shadow DOM引用
			shadowRoot: null,
			// 提取共享样式，避免重复定义
			baseStyles: `
        <style>
          pre {
            white-space: pre-wrap;
            word-wrap: break-word;
            font-family: arial;
          }
        </style>
      `,
		};
	},
	methods: {
		/**
		 * 初始化Shadow DOM
		 * @returns {boolean} 初始化是否成功
		 */
		initShadowDOM() {
			const container = this.$refs.container;

			if (!container) {
				console.error('容器元素不存在，无法初始化Shadow DOM');
				return false;
			}

			try {
				// 优先使用现代API
				if (container.attachShadow) {
					this.shadowRoot = container.attachShadow({ mode: this.shadowMode });
				}
				// 兼容旧版API
				else if (container.createShadowRoot) {
					this.shadowRoot = container.createShadowRoot();
				} else {
					console.error('当前浏览器不支持Shadow DOM');
					return false;
				}

				return true;
			} catch (error) {
				console.error('初始化Shadow DOM失败:', error);
				return false;
			}
		},

		/**
		 * 更新Shadow DOM中的内容
		 * @param {string} content - 需要渲染的内容
		 */
		updateShadowContent(content) {
			if (!this.shadowRoot) {
				console.warn('Shadow DOM尚未初始化，无法更新内容');
				return;
			}

			try {
				// 结合基础样式和内容更新Shadow DOM
				this.shadowRoot.innerHTML = this.baseStyles + (content || '');
			} catch (error) {
				console.error('更新Shadow DOM内容失败:', error);
			}
		},
	},
	mounted() {
		// 初始化Shadow DOM并渲染初始内容
		if (this.initShadowDOM()) {
			this.updateShadowContent(this.content);
		}
	},
	watch: {
		/** 监听content变化，实时更新Shadow DOM */
		content: {
			handler(newVal) {
				this.updateShadowContent(newVal);
			},
			immediate: false,
		},

		/** 监听shadowMode变化，重新初始化Shadow DOM */
		shadowMode: {
			handler() {
				if (this.initShadowDOM()) {
					this.updateShadowContent(this.content);
				}
			},
		},
	},
};
</script>
